import { STATUSES } from "../../../../enums/AppointmentStatus";
import { REJECT_PENDING } from "../../../../enums/PermissionTitles";
import { CLINIC_TYPE } from "../../../master/clinicList/utils/clinicFields";

/** Whether the current role may edit, accept or cancel the appointment at all. */
export function canManageAppointment(appointment, roles) {
  if (roles.master) {
    return true;
  } else if (roles.adminOrEmployee) {
    return appointment?.status !== STATUSES.INACTIVE;
  }
  return isAwaitingConfirmation(appointment);
}

/** Whether a pending appointment can be accepted or rejected rather than deleted. */
export function canChangePendingStatus(appointment, isPermissionAllowed) {
  return (
    isPermissionAllowed(REJECT_PENDING) && isAwaitingConfirmation(appointment)
  );
}

/** Whether a master may mark a waiting appointment at a clinic outside Zookeeper as accepted, after contacting the clinic. */
export function canMarkNonSystemAccepted(appointment, clinicType, roles) {
  return (
    isMasterHandlingNonSystem(clinicType, roles) &&
    appointment?.status === STATUSES.WAITING_CLINIC
  );
}

/** Whether a master may move an accepted appointment at a clinic outside Zookeeper back to pending. */
export function canMarkNonSystemPending(appointment, clinicType, roles) {
  return (
    isMasterHandlingNonSystem(clinicType, roles) &&
    appointment?.status === STATUSES.ACTIVE
  );
}

/** Whether a master may cancel a waiting or accepted appointment at a clinic outside Zookeeper. */
export function canMasterCancelNonSystem(appointment, clinicType, roles) {
  return (
    canMarkNonSystemAccepted(appointment, clinicType, roles) ||
    canMarkNonSystemPending(appointment, clinicType, roles)
  );
}

function isMasterHandlingNonSystem(clinicType, roles) {
  return !!roles?.master && clinicType === CLINIC_TYPE.NON_SYSTEM;
}

function isAwaitingConfirmation(appointment) {
  return (
    appointment?.status === STATUSES.WAITING_CLINIC ||
    appointment?.status === STATUSES.WAITING_USER
  );
}
